import React from 'react';
import { useTranslation } from 'react-i18next';
import { TableCustom, SearchBarBox, HeadlinePage } from 'components/common';
import { Paper } from '@mui/material';
import { useForm } from 'react-hook-form';
import StopCircleOutlinedIcon from '@mui/icons-material/StopCircleOutlined';
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import { withPermission } from 'hoc';


const JobListDumb = ({
  handleSearch,
  defaultValues,
  searchValue,
  content,
  options,
  isLoaded,
  handleStopJob,
  handleStopJobAll,
  handleView,
  validPermission
}) => {
  const methods = useForm({ defaultValues });
  const projectId = methods.getValues("project");
  const [t] = useTranslation();

  const onSubmit = (data) => {
    handleSearch(data);
  };

  const onStopJob = (job) => handleStopJob(job);

  const onView = (job) => {
    if (validPermission(projectId, 'isVisible')){
      handleView(job);
    }
  }

  const columns = [
    { label: '', key: 'status', type: 'status', sx: { width: 0, pr: 0 } },
    { label: t('common.components.table.col.name'), key: 'name' },
    { label: t('jobList.components.table.col.type'), key: 'type', type: 'chip' },
  ];

  const createActions = () => {
    const actions = [];

    if (validPermission(projectId, 'isVisible')) actions.push({
      label: t('jobList.components.table.view'),
      icon: <VisibilityOutlinedIcon color="primary" />,
      handle: onView,
    });
    if (validPermission(projectId, 'isExecute')) actions.push({
      label: t('jobList.components.table.stop'),
      icon: <StopCircleOutlinedIcon color='primary'/>,
      handle: onStopJob,
      stop: true
    });

    actions.push({ label: t('jobList.components.table.children'), handle: 'children' });
    return actions;
  }

  const createChildrenActions = () => {
    const childrenActions = [];

    if (validPermission(projectId, 'isVisible')) childrenActions.push({
      label: t('jobList.components.table.view'),
      icon: <VisibilityOutlinedIcon color="primary" />,
      handle: onView,
    });
    if (validPermission(projectId, 'isExecute')) childrenActions.push({
      label: t('jobList.components.table.stop'),
      icon: <StopCircleOutlinedIcon color='primary'/>,
      handle: onStopJob,
      stop: true
    });

    return childrenActions;
  }

  const actions = createActions();
  const childrenActions = createChildrenActions();

  const childrenColumns = [
    { label: '', key: 'status', type: 'status', sx: { width: 0, pr: 0 } },
    { label: t('common.components.table.col.name'), key: 'name' },
    { label: t('jobList.components.table.col.type'), key: 'type', type: 'chip' },
  ];

  return (
    <>
      <HeadlinePage
        title="jobList.headline"
        buttonLabel={validPermission(projectId, 'isExecute') ? 'jobList.components.abort' : ""}
        handleOnClick={handleStopJobAll}
      />

      <SearchBarBox
        onSubmit={onSubmit}
        methods={methods}
        options={options}
        searchValue={searchValue}
        hideMacro={false}
      />

      <Paper sx={{ p: 2 }}>
        <TableCustom
          title="jobList.components.titleList"
          columns={columns}
          childrenColumns={childrenColumns}
          content={content}
          loading={isLoaded}
          actions={actions}
          childrenActions={childrenActions}
          handleOnClickRow={onView}
        />
      </Paper>
    </>
  )
}

export default withPermission(JobListDumb, "jobs");
